import * as React from 'react';
import clsx from 'clsx';

import { ID } from 'src/models';
import { Checkbox } from 'src/components/Checkbox';

import classes from './Item.module.scss';

interface Props {
  id: ID;
  label: string;
  onClick: () => void;
  onMouseEnter?: () => void;
  isDisabled?: boolean;
  isSmall?: boolean;
  isSelected?: boolean;
  isSplitAfter?: boolean;
  isHighlightedText?: boolean;
  isActive?: boolean;
  isChecked?: boolean;
  isIndeterminate?: boolean;
  className?: string;
  depth?: number;
}

export function Item({
  id,
  label,
  onClick,
  onMouseEnter,
  isDisabled,
  isSmall,
  isSelected,
  isSplitAfter,
  isHighlightedText,
  isActive,
  isChecked,
  isIndeterminate,
  className,
  depth = 0,
}: Props) {
  function handleOnClick(e: React.MouseEvent) {
    e.stopPropagation();

    if (!isDisabled) {
      onClick();
    }
  }

  function renderContent() {
    return (
      <Checkbox
        isChecked={isChecked}
        label={label}
        isIndeterminate={isIndeterminate}
        isDisabled={isDisabled}
        isSmall={isSmall}
        isSmallCheckbox
      />
    );
  }

  return (
    <div
      data-testid={`menu-item-${id}`}
      className={clsx(
        'row a-center w-100p',
        classes.container,
        classes[`depth-${depth}`],
        {
          [classes.small]: isSmall,
          [classes.selected]: isSelected,
          [classes['split-after']]: isSplitAfter,
          [classes['highlight-text']]: isHighlightedText,
          [classes.active]: isActive,
          [classes.disabled]: isDisabled,
        },
        className,
      )}
      style={{ paddingLeft: `${1.4 + depth * 2}rem` }}
      onClick={handleOnClick}
      onMouseEnter={onMouseEnter}
    >
      {renderContent()}
    </div>
  );
}
